import script from "./LoginUserPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginUserPhone.vue?vue&type=script&setup=true&lang=js"

import "./LoginUserPhone.vue?vue&type=style&index=0&id=65431e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65431e24"]])

export default __exports__